(function () {
  const DATA_SELECTOR = '.product-image-download-data';
  const DOWNLOAD_TYPES = ['views', 'actions'];

  function parseJSONScript(script) {
    if (!script) return null;

    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      console.error('[powerslide-b2b] Invalid product image download JSON:', error);

      return null;
    }
  }

  const VIEW_KEYS = new Set(['view', 'views']);
  const ACTION_KEYS = new Set(['action', 'actions']);

  function normalizeUrlEntry(entry) {
    if (typeof entry === 'string') {
      return entry.trim();
    }

    if (!entry || typeof entry !== 'object') {
      return '';
    }

    for (const k of ['url', 'src', 'href', 'link', 'path']) {
      if (typeof entry[k] === 'string' && entry[k].trim()) {
        return entry[k].trim();
      }
    }

    return '';
  }

  function flattenImageList(raw) {
    if (raw === null || raw === undefined || raw === '') {
      return [];
    }

    if (Array.isArray(raw)) {
      return raw.map(normalizeUrlEntry).filter(Boolean);
    }

    if (typeof raw === 'string') {
      const t = raw.trim();
      if (!t) {
        return [];
      }

      if (t.startsWith('[') || t.startsWith('{')) {
        try {
          return flattenImageList(JSON.parse(t));
        } catch (error) {
          return [normalizeUrlEntry(t)].filter(Boolean);
        }
      }

      if (t.includes(',') && (t.includes('http') || t.includes('/'))) {
        return t
          .split(',')
          .map(part => normalizeUrlEntry(part.trim()))
          .filter(Boolean);
      }

      return [normalizeUrlEntry(t)].filter(Boolean);
    }

    if (typeof raw === 'object') {
      const single = normalizeUrlEntry(raw);

      if (single) {
        return [single];
      }

      return Object.values(raw).flatMap(flattenImageList);
    }

    return [];
  }

  function normalizeImages(raw) {
    let source = raw;

    if (source === null || source === undefined || source === '') {
      return { views: [], actions: [] };
    }

    if (typeof source === 'string') {
      try {
        source = JSON.parse(source.trim());
      } catch (error) {
        return { views: [], actions: [] };
      }
    }

    if (Array.isArray(source)) {
      return {
        views: flattenImageList(source),
        actions: []
      };
    }

    if (typeof source !== 'object') {
      return { views: [], actions: [] };
    }

    let views = [];
    let actions = [];
    Object.keys(source).forEach(key => {
      const normalizedKey = key.toLowerCase();

      if (
        !VIEW_KEYS.has(normalizedKey) &&
        !ACTION_KEYS.has(normalizedKey)
      ) {
        return;
      }

      const flat = flattenImageList(source[key]);

      if (VIEW_KEYS.has(normalizedKey)) {
        views = views.concat(flat);
      } else if (ACTION_KEYS.has(normalizedKey)) {
        actions = actions.concat(flat);
      }
    });

    return { views, actions };
  }

  function normalizeProduct(product) {
    if (!product) return null;

    let imagesRaw = product.images || product.downloadImages;

    if (typeof imagesRaw === 'string') {
      try {
        imagesRaw = JSON.parse(imagesRaw.trim());
      } catch (error) {
        imagesRaw = {};
      }
    }

    const images = normalizeImages(imagesRaw);
    let sizeChartUrl = '';
    if (product.sizeChartUrl && String(product.sizeChartUrl).trim()) {
      sizeChartUrl = String(product.sizeChartUrl)
        .trim()
        .replace(/^http:\/\//i, 'https://');
    }

    return {
      handle: product.handle || '',
      title: product.title || product.handle || 'Product',
      reference: product.reference || product.handle || 'product',
      images,
      sizeChartUrl
    };
  }

  function getProductsFromScripts(context) {
    return Array.from(document.querySelectorAll(DATA_SELECTOR))
      .filter(script => !context || script.dataset.downloadContext === context)
      .map(parseJSONScript)
      .map(normalizeProduct)
      .filter(product => product && hasImages(product));
  }

  function hasImages(product) {
    return (
      product.images.views.length > 0 ||
      product.images.actions.length > 0 ||
      Boolean(product.sizeChartUrl)
    );
  }

  function getZipWrapper(button) {
    return button.closest(
      '[data-product-image-downloads],[data-download-cart-images],[data-download-secondary-cart-images]'
    );
  }

  function hideError(wrapper) {
    if (!wrapper) return;
    const el = wrapper.querySelector('[data-download-error]');

    if (el) {
      el.textContent = '';
      el.classList.add('hidden');
    }
  }

  let errorTimers = {};

  function showError(button, message) {
    const wrapper = getZipWrapper(button);
    const el = wrapper?.querySelector('[data-download-error]');

    if (!el) return;

    const key = wrapper.getAttribute('data-error-key') || String(Math.random());

    if (!wrapper.getAttribute('data-error-key')) {
      wrapper.setAttribute('data-error-key', key);
    }

    if (errorTimers[key]) {
      window.clearTimeout(errorTimers[key]);
    }

    el.textContent = message;
    el.classList.remove('hidden');

    errorTimers[key] = window.setTimeout(() => {
      el.classList.add('hidden');
      el.textContent = '';
      delete errorTimers[key];
    }, 6500);
  }

  function setButtonLoading(button, loading) {
    if (!button) return;

    button.disabled = loading;
    button.setAttribute('aria-busy', loading ? 'true' : 'false');

    const idle = button.querySelector('[data-download-btn-idle]');
    const spinner = button.querySelector('[data-download-btn-spinner]');

    if (idle) {
      idle.classList.toggle('hidden', loading);
    }

    if (spinner) {
      spinner.classList.toggle('hidden', !loading);
    }
  }

  function setLinkedPdpButtonsLoading(activeButton, loading) {
    document
      .querySelectorAll('[data-download-product-images-zip]')
      .forEach(btn => setButtonLoading(btn, loading));
  }

  function setDownloadLoading(button, loading) {
    if (button && button.matches('[data-download-product-images-zip]')) {
      setLinkedPdpButtonsLoading(button, loading);
    } else {
      setButtonLoading(button, loading);
    }
  }

  function getFileNameFromUrl(url, fallback) {
    try {
      const parsedUrl = new URL(url, window.location.origin);
      const rawName = parsedUrl.pathname.split('/').filter(Boolean).pop();

      if (rawName) {
        return decodeURIComponent(rawName).replace(/[\\/:*?"<>|]+/g, '-');
      }
    } catch (error) {
      // Fall back below for malformed but still downloadable URLs.
    }

    return fallback;
  }

  function slugify(value) {
    return (
      String(value || 'product')
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '') || 'product'
    );
  }

  function formatZipDateYYYYMMDD() {
    const d = new Date();
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');

    return `${y}-${m}-${day}`;
  }

  function buildProductPageZipBasename(product) {
    return (
      slugify(product.reference || product.handle || 'product') || 'product'
    );
  }

  function collectDownloadItems(products, types) {
    const items = [];

    products.forEach(product => {
      const productFolder = slugify(
        product.reference || product.handle || product.title
      );

      types.forEach(type => {
        const urls = product.images[type] || [];

        urls.forEach((url, index) => {
          const fallback = `${productFolder}-${type}-${index + 1}.jpg`;
          const fileName = getFileNameFromUrl(url, fallback);

          items.push({
            url,
            path: `${productFolder}/${type}/${fileName}`,
            fileName
          });
        });
      });

      if (product.sizeChartUrl) {
        const chartUrl = String(product.sizeChartUrl).trim();
        const fallbackBase = `${productFolder}-size-chart`;
        const fileName = getFileNameFromUrl(chartUrl, `${fallbackBase}.pdf`);

        items.push({
          url: chartUrl,
          path: `${productFolder}/${fileName}`,
          fileName
        });
      }
    });

    return items;
  }

  async function fetchImageBytes(url) {
    const response = await fetch(url, { mode: 'cors' });

    if (!response.ok) {
      throw new Error(`Could not fetch ${url}`);
    }

    return new Uint8Array(await response.arrayBuffer());
  }

  async function runZipDownload(products, fileName, triggerButton) {
    const items = collectDownloadItems(products, DOWNLOAD_TYPES);

    if (items.length === 0) {
      showError(
        triggerButton,
        'No images available to download for this selection.'
      );
      return;
    }

    hideError(getZipWrapper(triggerButton));
    setDownloadLoading(triggerButton, true);

    try {
      const files = [];

      for (const item of items) {
        files.push({
          path: item.path,
          data: await fetchImageBytes(item.url)
        });
      }

      const zipBlob = createZip(files);
      triggerBlobDownload(zipBlob, fileName);
    } catch (error) {
      console.error('[powerslide-b2b] Image ZIP failed:', error);
      showError(
        triggerButton,
        'Could not create ZIP. Check your connection or image host (CORS).'
      );
    } finally {
      setDownloadLoading(triggerButton, false);
    }
  }

  function triggerBlobDownload(blob, fileName) {
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');

    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    link.remove();

    window.setTimeout(() => URL.revokeObjectURL(url), 1000);
  }

  function createZip(files) {
    const localParts = [];
    const centralParts = [];
    let offset = 0;

    files.forEach(file => {
      const fileName = new TextEncoder().encode(file.path);
      const data = file.data;
      const crc = crc32(data);
      const dateParts = getDosDateTime(new Date());
      const localHeader = createLocalHeader(fileName, data.length, crc, dateParts);
      const centralHeader = createCentralHeader(
        fileName,
        data.length,
        crc,
        dateParts,
        offset
      );

      localParts.push(localHeader, fileName, data);
      centralParts.push(centralHeader, fileName);

      offset += localHeader.length + fileName.length + data.length;
    });

    const centralSize = centralParts.reduce((sum, part) => sum + part.length, 0);
    const endRecord = createEndRecord(files.length, centralSize, offset);

    return new Blob([...localParts, ...centralParts, endRecord], {
      type: 'application/zip'
    });
  }

  function createLocalHeader(fileName, size, crc, dateParts) {
    const header = new Uint8Array(30);
    const view = new DataView(header.buffer);

    view.setUint32(0, 0x04034b50, true);
    view.setUint16(4, 20, true);
    view.setUint16(6, 0x0800, true);
    view.setUint16(8, 0, true);
    view.setUint16(10, dateParts.time, true);
    view.setUint16(12, dateParts.date, true);
    view.setUint32(14, crc, true);
    view.setUint32(18, size, true);
    view.setUint32(22, size, true);
    view.setUint16(26, fileName.length, true);
    view.setUint16(28, 0, true);

    return header;
  }

  function createCentralHeader(fileName, size, crc, dateParts, offset) {
    const header = new Uint8Array(46);
    const view = new DataView(header.buffer);

    view.setUint32(0, 0x02014b50, true);
    view.setUint16(4, 20, true);
    view.setUint16(6, 20, true);
    view.setUint16(8, 0x0800, true);
    view.setUint16(10, 0, true);
    view.setUint16(12, dateParts.time, true);
    view.setUint16(14, dateParts.date, true);
    view.setUint32(16, crc, true);
    view.setUint32(20, size, true);
    view.setUint32(24, size, true);
    view.setUint16(28, fileName.length, true);
    view.setUint16(30, 0, true);
    view.setUint16(32, 0, true);
    view.setUint16(34, 0, true);
    view.setUint16(36, 0, true);
    view.setUint32(38, 0, true);
    view.setUint32(42, offset, true);

    return header;
  }

  function createEndRecord(fileCount, centralSize, centralOffset) {
    const record = new Uint8Array(22);
    const view = new DataView(record.buffer);

    view.setUint32(0, 0x06054b50, true);
    view.setUint16(4, 0, true);
    view.setUint16(6, 0, true);
    view.setUint16(8, fileCount, true);
    view.setUint16(10, fileCount, true);
    view.setUint32(12, centralSize, true);
    view.setUint32(16, centralOffset, true);
    view.setUint16(20, 0, true);

    return record;
  }

  function getDosDateTime(date) {
    const time =
      (date.getHours() << 11) |
      (date.getMinutes() << 5) |
      Math.floor(date.getSeconds() / 2);
    const year = Math.max(date.getFullYear(), 1980);
    const dosDate =
      ((year - 1980) << 9) | ((date.getMonth() + 1) << 5) | date.getDate();

    return { time, date: dosDate };
  }

  function crc32(bytes) {
    let crc = -1;

    for (let i = 0; i < bytes.length; i++) {
      crc = (crc >>> 8) ^ CRC_TABLE[(crc ^ bytes[i]) & 0xff];
    }

    return (crc ^ -1) >>> 0;
  }

  const CRC_TABLE = (function () {
    const table = new Uint32Array(256);

    for (let i = 0; i < 256; i++) {
      let c = i;

      for (let k = 0; k < 8; k++) {
        c = c & 1 ? 0xedb88320 ^ (c >>> 1) : c >>> 1;
      }

      table[i] = c >>> 0;
    }

    return table;
  })();

  function initProductPageDownloads() {
    const script = document.querySelector(
      `${DATA_SELECTOR}[data-download-context="product"]`
    );

    if (!script) return;

    const raw = parseJSONScript(script);

    if (!raw) return;

    const product = normalizeProduct(raw);

    if (!product || !hasImages(product)) {
      document.querySelectorAll('[data-product-image-downloads]').forEach(el => {
        el.hidden = true;
      });

      return;
    }

    document
      .querySelectorAll('[data-download-product-images-zip]')
      .forEach(button => {
        button.addEventListener('click', () => {
          hideError(getZipWrapper(button));
          runZipDownload(
            [product],
            `product-images_${buildProductPageZipBasename(product)}.zip`,
            button
          );
        });
      });
  }

  function bindCartDownloads() {
    document.querySelectorAll('[data-download-cart-images]').forEach(container => {
      const products = getProductsFromScripts(
        container.dataset.downloadContext || 'cart'
      );

      if (!products.length) {
        container.style.display = 'none';
        return;
      }

      const button = container.querySelector('[data-download-cart-images-button]');

      if (!button) return;

      button.addEventListener('click', () => {
        hideError(container);
        runZipDownload(
          products,
          `cart-product-images_${formatZipDateYYYYMMDD()}.zip`,
          button
        );
      });
    });
  }

  function bindSecondaryCartDownloads() {
    document
      .querySelectorAll('[data-download-secondary-cart-images]')
      .forEach(container => {
        const button = container.querySelector(
          '[data-download-secondary-cart-images-button]'
        );

        if (!button) return;

        button.addEventListener('click', () => {
          const config =
            window.MODES_CONFIG && window.MODES_CONFIG[window.cartMode];
          const cartKey = config && config.cartKey;
          const rawCart = cartKey
            ? JSON.parse(localStorage.getItem(cartKey) || '{}')
            : {};

          const products = Object.keys(rawCart)
            .map(handle =>
              normalizeProduct({
                handle,
                title: rawCart[handle].title,
                reference: rawCart[handle].reference || handle,
                images: rawCart[handle].downloadImages,
                sizeChartUrl: rawCart[handle].sizeChartUrl
              })
            )
            .filter(item => item && hasImages(item));

          const modePrefix =
            config && config.prefix ? config.prefix.toLowerCase() : 'alt-order';

          hideError(container);

          if (!products.length) {
            showError(button, 'No downloadable images saved in this cart.');
            return;
          }

          runZipDownload(
            products,
            `${modePrefix}-cart-product-images_${formatZipDateYYYYMMDD()}.zip`,
            button
          );
        });
      });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initProductPageDownloads();
    bindCartDownloads();
    bindSecondaryCartDownloads();
  });

  window.ProductImageDownloads = {
    normalizeImages,
    getProductsFromScripts
  };
})();
